import React from "react"
import { observer } from "mobx-react-lite"
import { SVGPureIcon } from '@/ui';
import {
  Swiper,
  SwiperSlide,
} from "swiper/react"
import ExampleItem from '@/components/examples/example-item';
import "./swiper.scss"
import navbarStore from "@/store/navbar";
import useWindowSize from '@/hooks/useWindowSize'
import { debounce } from 'lodash-es'

function SayList(props) {
  const { send, data: saylist_example } = props
  if (!saylist_example) return null
  const [winWidth] = useWindowSize();
  React.useEffect(debounce(() => {
    const btnPrev = document.querySelector('.swiper-btn-prev')
    const btnNext = document.querySelector('.swiper-btn-next')
    // 侧边栏展开或折叠，要有不同的wl值
    const wl = navbarStore.isCollapse ? 820 : 1070
    if (btnPrev) {
      if (winWidth < wl) {
        btnPrev.style.left = '4px'
      } else {
        btnPrev.style.left = ''
      }
    }
    if (btnNext) {
      if (winWidth < wl) {
        btnNext.style.right = '4px'
      } else {
        btnNext.style.right = ''
      }
    }
  }, 500), [winWidth, navbarStore.isCollapse]);

  return (
    <>
      <h3 className="w-full mb-12px text-fold-500 text-14px text-black text-opacity-50 leading-16px text-left">推荐作品:</h3>
      <div className="swiper-custom w-800px">
        <Swiper
          className="w-full !pb-10px"
          direction="horizontal"
          pagination={
            {
              el: '.swiper-pagination-wrap',
              type: 'bullets',
              clickable: true,
            }
          }
          slidesPerView={5}
          navigation={{
            prevEl: '.swiper-btn-prev',
            nextEl: '.swiper-btn-next'
          }}
        >
          {
            saylist_example?.map((item, index) => {
              return (
                <SwiperSlide key={index} className="px-6px">
                  <ExampleItem data={item} className="agent-landing-page-item" scene="agent_landing_page" />
                </SwiperSlide>
              )
            })
          }
        </Swiper>
        {
          saylist_example?.length > 5 ? (
            <>
              <div className='swiper-btn-prev text-[rgba(0,0,0,0.5)] '>
                <div className='swiper-btn-circle'>
                  <SVGPureIcon name="swiper_agent_prev" className="size-21px" />
                </div>
              </div>
              <div className='swiper-btn-next text-[rgba(0,0,0,0.5)] '>
                <div className='swiper-btn-circle'>
                  <SVGPureIcon name="swiper_agent_next" className="size-21px" />
                </div>
              </div>
              <div className="swiper-pagination-wrap right-0 -top-21px"></div>
            </>
          ) : null
        }
      </div>
    </>
  )
}

export default observer(SayList)
